import { ParameterField, ValidationResult } from './validatePendingParameters';

type TFn = (key: string, opts?: Record<string, unknown>) => string;

const FIELD_NOUN_KEYS: Record<ParameterField, string> = {
	groupSize: 'errors.field_party_size',
	date: 'errors.field_date',
	time: 'errors.field_time'
};

const FIELD_ORDER: ParameterField[] = ['groupSize', 'date', 'time'];

export function buildUnsetParametersMessage(
	errors: ValidationResult['errors'],
	t: TFn
): string | null {
	const nouns = FIELD_ORDER.filter((field) => errors[field]).map((field) => t(FIELD_NOUN_KEYS[field]));
	if (nouns.length === 0) {
		return null;
	}

	let fields: string;
	if (nouns.length === 1) {
		fields = nouns[0];
	}
	else {
		const head = nouns.slice(0, -1).join(', ');
		fields = `${head} ${t('errors.list_and', { defaultValue: 'and' })} ${nouns[nouns.length - 1]}`;
	}

	return t('errors.select_unset', { fields, defaultValue: `Please select a ${fields}` });
}
